export function getInitiative(state) {
  return state.initiative;
}

export function getTableHeaderInitiative(state) {
  return state.tableHeaderInitiative;
}
